import {
  resource,
  composeReducers,
} from 'common/store/reducer';

import {
  NAMESPACE, LOAD_DEVICE_DASHBOARD, LOAD_DEVICE_DASHBOARD_SUCCESS
} from './actions';

const initialState = {
  geoLocation: {
    latitude: undefined,
    longitude: undefined,
    altitude: undefined,
  }
};

const loadDeviceDashboard = (state) => {
    return{
      ...state,
  }
}

const loadDeviceDashboardSuccess = (state, {dets}) => {
    return{
      ...state,
      geoLocation: {
        latitude: dets.latitude,
        longitude: dets.longitude,
        altitude: dets.altitude,
      }
  }
}

const collectionReducer = (state = initialState, action) => {
  const reducer = {
    [LOAD_DEVICE_DASHBOARD]: loadDeviceDashboard,
    [LOAD_DEVICE_DASHBOARD_SUCCESS]: loadDeviceDashboardSuccess,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};

export default composeReducers(
  resource.factory(NAMESPACE),
  collectionReducer,
  (state = initialState) => state,
);
